export const Role = {
    SUPER: 'ROLE_SUPER',
    ADMIN: 'ROLE_ADMIN',
    OPERATOR: 'ROLE_OPERATOR',
    USER: 'ROLE_USER'
};